import { createAuthenticatedGraphQLClient } from '../../auth/createAuthenticatedGraphQLClient';
import type { RuntimeEnvironment } from '../../graphql/config/runtimeConfig';
import type {
  DeleteCanvassingSessionPipelineJobMutation,
  DeleteCanvassingSessionPipelineJobMutationVariables,
} from '../../graphql/queries/deleteCanvassingSessionPipelineJob.generated';
import { DELETE_CANVASSING_SESSION_PIPELINE_JOB_DOCUMENT } from '../canvassingSessionDocuments';

export type DeleteCanvassingSessionPipelineJobClientOverrides = {
  env: RuntimeEnvironment;
  fetchImpl?: Parameters<typeof createAuthenticatedGraphQLClient>[0]['fetchImpl'];
};

export const DELETE_CANVASSING_SESSION_PIPELINE_JOB_ERROR_MESSAGE = 'Could not delete the job. Try again.';

export const deleteCanvassingSessionPipelineJob = async (
  sessionId: string,
  jobId: number,
  overrides: DeleteCanvassingSessionPipelineJobClientOverrides,
): Promise<boolean> => {
  const client = createAuthenticatedGraphQLClient(overrides);
  const variables: DeleteCanvassingSessionPipelineJobMutationVariables = { sessionId, jobId };
  const result = await client.request<DeleteCanvassingSessionPipelineJobMutation>({
    document: DELETE_CANVASSING_SESSION_PIPELINE_JOB_DOCUMENT,
    variables,
  });

  return result.deleteCanvassingSessionPipelineJob;
};
